var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.355,20H3.645A3.649,3.649,0,0,1,0,16.355V3.645A3.649,3.649,0,0,1,3.645,0h12.71A3.649,3.649,0,0,1,20,3.645v12.71A3.649,3.649,0,0,1,16.355,20ZM11.81,12.727a.909.909,0,0,0,0,1.819h.917v.9a.909.909,0,1,0,1.819,0v-.9h.917a.909.909,0,0,0,0-1.819h-.917V4.551a.909.909,0,1,0-1.819,0v8.176ZM4.537,5.455a.909.909,0,0,0,0,1.818h.918v8.176a.909.909,0,1,0,1.818,0V7.273H8.19a.909.909,0,0,0,0-1.818H7.273v-.9a.909.909,0,1,0-1.818,0v.9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.5bd67110163a925b1e9541c62d224cd0.svg";
export { ForwardRef as ReactComponent };